<template>
  <div class="indexer mb-1">
    <div class="index-container mr-1">
      <number-field
        id="list-indexer"
        :label="description"
        placeholder="Choose an index..."
        :min-value="1"
        v-model="index"
      >
      </number-field>
    </div>
    <div class="d-flex">
      <button
        class="btn btn-primary"
        type="button"
        :disabled="!resolveEnabled"
        @click="resolveClicked"
      >
        Resolve
      </button>
      <button class="btn btn-primary ml-1" type="button" @click="asListClicked">
        Add as List
      </button>
    </div>
  </div>
</template>
<script>
export default {
  data: function() {
    return {
      index: 1,
    };
  },
  computed: {
    resolveEnabled: function() {
      return this.index > 0;
    },
    description: function() {
      if (this.index > 0) {
        const stringValue = this.index.toString();
        const lastDigit = stringValue.charAt(stringValue.length - 1);
        const is11to13 = this.index >= 11 && this.index <= 13;

        let suffix;
        if (lastDigit === "1" && !is11to13) {
          suffix = "st";
        } else if (lastDigit === "2" && !is11to13) {
          suffix = "nd";
        } else if (lastDigit === "3" && !is11to13) {
          suffix = "rd";
        } else {
          suffix = "th";
        }

        return `${this.index}${suffix} item`;
      }

      return "";
    },
  },
  methods: {
    resolveClicked: function() {
      this.$emit("resolve", this.index);
    },
    asListClicked: function() {
      this.$emit("as-list");
    },
  },
  emits: ["resolve", "as-list"],
};
</script>
<style lang="scss" scoped>
.indexer {
  display: flex;
  justify-content: space-between;
  align-items: flex-end;

  & > .index-container {
    flex-grow: 1;
  }

  & > .description {
    font-size: 1.1rem;
    font-weight: bold;
    white-space: nowrap;
    margin-right: 1rem;
  }
}
</style>
